import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

export const DisclaimerShort = ({ withSeeMoreBtn }) => {
  const { t } = useTranslation();
  return (
    <>
      <Trans i18nKey="app.disclaimerSnippet">
        Please read this disclaimer carefully before using the COVID19 Recommendations and Gateway
        to Contextualization (
        <Link to="/" className="text-covid-100 hover:opacity-50">
          https://covid19.recmap.org/
        </Link>
        ) website.
      </Trans>{" "}
      {withSeeMoreBtn && (
        <Link className="text-covid-100 hover:opacity-50" to="/about">
          {t("labels.see_more")}
        </Link>
      )}
    </>
  );
};

DisclaimerShort.propTypes = {
  withSeeMoreBtn: PropTypes.bool,
};

DisclaimerShort.defaultProps = {
  withSeeMoreBtn: false,
};
